<template>
  <div class="pageContol exam-house-monitor">
    <div class="framePage">
      <!-- <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">考试管理</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">考试大屏</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">考试仓</a>

        </span>
      </div> -->
      <div id="monitor-content" class="framePage-body monitor-container">
        <!-- 添加考试仓名称居中标题 -->
        <div class="exam-house-title">
          <h2>{{ examHouseName }}</h2>
          <button class="alarm-reset-btn" @click="resetAlarm" title="报警复位">
            报警复位<i class="el-icon-refresh"></i>
          </button>
          <button class="back-btn" @click="$router.back()">
            <i class="el-icon-back"></i>
          </button>
          <button class="fullscreen-btn" @click="toggleFullScreen">
            <i :class="isFullscreen ? 'el-icon-full-screen' : 'el-icon-full-screen'"></i>
          </button>
        </div>

        <div class="video-monitors">
          <div class="video-grid">
            <div v-for="camera in cameras" :key="camera.id" class="video-item">

              <div class="video-header">
                <h4>{{ camera.name }}</h4>
              </div>
              <div class="video-content">
                <!-- TODO 视频流 -->
                <img v-if="!camera.playUrl" src="@/assets/BG.png" :alt="camera.name" />
                <div v-else :id='"ezuikit-player-" + camera.id'></div>
              </div>
            </div>
          </div>
        </div>

        <div class="device-status">
          <div class="device-title">
            <h3>设备状态</h3>
          </div>

          <!-- 环境监测和考生行为预警在一行显示 -->
          <div class="monitor-alerts-container">
            <!-- 环境监测 -->
            <div class="environment-monitor">
              <h4>环境监测</h4>
              <div class="environment-items">
                <div class="environment-item">
                  <span class="item-label">温度:</span>
                  <span class="item-value">{{ environmentData.temperature }}°C</span>
                </div>
                <div class="environment-item">
                  <span class="item-label">湿度:</span>
                  <span class="item-value">{{ environmentData.humidity }}%</span>
                </div>
                <div class="environment-item">
                  <span class="item-label">二氧化碳:</span>
                  <span class="item-value">{{ environmentData.co2 }} ppm</span>
                </div>
                <div class="environment-item">
                  <span class="item-label">PM2.5:</span>
                  <span class="item-value">{{ environmentData.pm25 }} μg/m³</span>
                </div>
                <div class="environment-item">
                  <span class="item-label">PM10:</span>
                  <span class="item-value">{{ environmentData.pm10 }} μg/m³</span>
                </div>
                <div class="environment-item">
                  <span class="item-label">TVOC:</span>
                  <span class="item-value">{{ environmentData.tvoc }} mg/m³</span>
                </div>
                <div class="environment-item">
                  <span class="item-label">甲醛:</span>
                  <span class="item-value">{{ environmentData.formaldehyde }} mg/m³</span>
                </div>
              </div>
            </div>

            <!-- 考生行为预警 -->
            <div class="exam-alerts">
              <h4>考生行为预警</h4>
              <div v-if="examAlerts.length > 0" class="alert-list">
                <div v-for="alert in examAlerts" :key="alert.id" class="alert-item">
                  <span class="alert-type">{{ alert.type }}</span>
                  <span class="alert-camera">{{ alert.cameraName }}</span>
                  <span class="alert-time">{{ alert.time }}</span>
                  <button v-if="alert.imgUrl" class="view-screenshot-btn" @click="viewScreenshot(alert.imgUrl)" title="查看截图">
                    <i class="el-icon-picture"></i> 查看
                  </button>
                </div>
              </div>
              <div v-else class="no-alerts">
                暂无预警信息
              </div>
            </div>
          </div>

          <div v-for="device in otherDevices" :key="device.id" class="other-device">
            <h4>{{ device.name }}</h4>
            <div class="device-status">
              <span class="status-indicator" :class="device.status === 'online' ? 'online' : 'offline'"></span>
              <span class="status-text">{{ device.status === 'online' ? '在线' : '离线' }}</span>
            </div>
            <div class="device-info">
              <p>{{ device.info }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 截图查看弹窗 -->
    <el-dialog
      :visible.sync="showScreenshotDialog"
      title="截图查看"
      width="50%"
      :custom-class="'screenshot-dialog'"
      :close-on-click-modal="true"
    >
      <div class="screenshot-container">
        <div v-if="currentScreenshotUrl" class="screenshot-wrapper">
          <img 
            :src="currentScreenshotUrl" 
            style="width: 100%;"
            alt="截图"
            class="screenshot-image"
            @error="handleImageError"
          />
        </div>
        <div v-else class="no-image">
          <i class="el-icon-picture-outline"></i>
          <p>暂无截图</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showScreenshotDialog = false">关闭</el-button>
      </span>
    </el-dialog>
    <dialog id="messageDialog">
        <h2>提示</h2>
        <p>{{ messageBox.message }}</p>
    </dialog>
  </div>
</template>

<script>
import EZUIKit from "ezuikit-js";
export default {
  name: 'ExamHouseMonitor',
  data() {
    return {
      examHouseId: '',
      examAreaId: '',
      examHouseName: '',
      examState: '',
      cameras: [],
      environmentData: {
        temperature: '-',
        humidity: '-',
        illumination: '-',
        noise: '-',
        co2: '-',
        pm25: '-',
        pm10: '-',
        atmosphericPressure: '-',
        tvoc: '-', // 总挥发性有机物
        formaldehyde: '-' // 甲醛
      },
      lockStatus: false,
      lockLoading: false,
      otherDevices: [],
      loading: false,
      isFullscreen: false,
      // WebSocket相关状态
      ws: null,
      wsConnected: false,
      reconnectInterval: 3000, // 重连间隔时间(ms)
      reconnectAttempts: 0, // 重连尝试次数
      maxReconnectAttempts: 10, // 最大重连尝试次数
      wsUrl: '', // WebSocket连接地址
      heartbeatInterval: 10000, // 心跳间隔10秒
      heartbeatTimer: null, // 心跳定时器
      businessCode: 'airSensor', // 业务代码
      businessId: '', // TODO 业务ID，暂时写死方便观察，后面需要从接口获取
      // 萤石播放器实例化
      playerVides: [],
      // 考生行为预警数据
      examAlerts: [],
      // 用户行为事件定时器
      userEventsTimer: null,
      // 用户行为事件请求间隔（10秒）
      userEventsInterval: 10000,
      // 截图查看弹窗相关状态
      showScreenshotDialog: false, // 控制弹窗显示/隐藏
      currentScreenshotUrl: '', // 当前要显示的截图URL
      messageBox: {
        defaultCount: 3,
        message: '',
        countdown: 0,
        timer: null
      }
    };
  },
  created() {
    this.examHouseId = this.$route.query.examHouseId || '';
    this.examAreaId = this.$route.query.examAreaId || '';
    this.examHouseName = this.$route.query.examHouseName || '';
    this.examState = this.$route.query.examState || '';
    if (this.examHouseId) {
      this.loadExamHouseData();
      // 启动用户行为事件获取定时器
      this.startUserEventsTimer();
    } else {
      this.showMessage('无效的考试仓');
      this.$router.go(-1);
    }
  },
  destroyed() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
    // 关闭WebSocket连接
    this.closeWebSocket();
    // 停止用户行为事件获取定时器
    this.stopUserEventsTimer();
  },
  methods: {
    /**
       * 查看截图方法
       * @param {string} imgUrl - 截图的URL地址
       */
      viewScreenshot(imgUrl) {
        // 验证图片URL是否存在
        if (!imgUrl) {
          this.showMessage('没有找到截图');
          return;
        }
        
        // 设置当前要显示的截图URL
        this.currentScreenshotUrl = imgUrl;
        // 显示截图弹窗
        this.showScreenshotDialog = true;
      },
      
      /**
       * 处理图片加载错误
       */
      handleImageError() {
        this.showMessage('图片加载失败');
        // 可选：设置默认占位图片
        // this.currentScreenshotUrl = '@/assets/error.png';
      },

    /**
     * 启动用户行为事件获取定时器
     */
    startUserEventsTimer() {
      this.stopUserEventsTimer(); // 先清除可能存在的定时器
      this.fetchUserEvents(); // 立即执行一次
      this.userEventsTimer = setInterval(() => {
        this.fetchUserEvents();
      }, this.userEventsInterval);
    },

    /**
     * 停止用户行为事件获取定时器
     */
    stopUserEventsTimer() {
      if (this.userEventsTimer) {
        clearInterval(this.userEventsTimer);
        this.userEventsTimer = null;
      }
    },

    /**
     * 获取用户行为事件数据
     */
    async fetchUserEvents() {
      try {
        let lastEventId = null;
        if (this.examAlerts && this.examAlerts.length > 0) {
          lastEventId = this.examAlerts[0].id;
        }
        const res = await this.$post(`/biz/isec/exam-house/getHouseCurrentUserDetails`, {
          examHouseId: this.examHouseId,
          lastEventId: lastEventId
        }, 3000, true, 6);
        if (res.status === '0') {
          const data = res.data;
          if (data) {
            this.examState = data.examHouse.examState || '';
            if (data.userEvents && data.userEvents.length > 0) {
              // 将userEvents数据转换为examAlerts格式
              const newAlerts = data.userEvents.map(event => ({
                id: event.id, // 确保id唯一
                type: event.remark || '未知事件', // remark对应type
                cameraName: event.deviceName || '未知设备', // deviceName对应cameraName
                time: event.createTime ? new Date(event.createTime).toLocaleTimeString() : new Date().toLocaleTimeString(), // createTime对应time
                imgUrl: event.imgUrl
              }));
              // 更新预警数据，避免重复
              this.examAlerts = [...newAlerts, ...this.examAlerts];
            }
          } else {
            this.examState = '';
            // 删除所有预警
            this.examAlerts = [];
          }
        }
      } catch (error) {
        console.error('获取用户行为事件数据失败:', error);
      }
    },

    /**
     * 启动心跳检测
     */
    startHeartbeat() {
      this.stopHeartbeat(); // 先清除可能存在的定时器
      this.heartbeatTimer = setInterval(() => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
          this.ws.send("ping");
        }
      }, this.heartbeatInterval);
    },
    /**
     * 停止心跳检测
     */
    stopHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
    },
    /**
     * 初始化WebSocket连接
     */
    initWebSocket() {
      // 构建WebSocket URL（将http替换为ws）
      const baseUrl = process.env.VUE_APP_EXAM_SERVER_LIB_URL;
      this.wsUrl = `${baseUrl}/open/ws?businessCode=${this.businessCode}&businessId=${this.businessId}`;
      this.createWebSocket();
    },

    /**
     * 创建WebSocket连接
     */
    createWebSocket() {
      try {
        this.ws = new WebSocket(this.wsUrl);
        this.initWebSocketEvents();
      } catch (error) {
        console.error('WebSocket创建失败:', error);
        this.reconnect();
      }
    },

    /**
     * 初始化WebSocket事件处理
     */
    initWebSocketEvents() {
      // 连接成功
      this.ws.onopen = this.handleWsOpen;
      // 接收消息
      this.ws.onmessage = this.handleWsMessage;
      // 连接关闭
      this.ws.onclose = this.handleWsClose;
      // 连接错误
      this.ws.onerror = this.handleWsError;
    },

    /**
     * WebSocket连接成功处理
     */
    handleWsOpen() {
      console.log('WebSocket连接成功');
      this.wsConnected = true;
      this.reconnectAttempts = 0; // 重置重连次数
      this.startHeartbeat(); // 启动心跳
    },

    /**
     * WebSocket接收消息处理
     */
    handleWsMessage(event) {
      try {
        const data = JSON.parse(event.data);
        this.updateEnvironmentData(data);
      } catch (error) {
        console.error('WebSocket消息解析失败:', error);
      }
    },

    /**
     * 更新环境数据
     */
    updateEnvironmentData(data) {
      if (data && data.crcValid) {
        this.environmentData = {
          ...this.environmentData,
          temperature: data.temperature !== undefined ? data.temperature : this.environmentData.temperature,
          humidity: data.humidity !== undefined ? data.humidity : this.environmentData.humidity,
          co2: data.co2 !== undefined ? data.co2 : this.environmentData.co2,
          pm25: data.pm25 !== undefined ? data.pm25 : this.environmentData.pm25,
          pm10: data.pm10 !== undefined ? data.pm10 : this.environmentData.pm10,
          tvoc: data.tvoc !== undefined ? data.tvoc : this.environmentData.tvoc,
          formaldehyde: data.formaldehyde !== undefined ? data.formaldehyde : this.environmentData.formaldehyde
        };
      }
    },

    /**
     * WebSocket连接关闭处理
     */
    handleWsClose() {
      console.log('WebSocket连接关闭');
      this.wsConnected = false;
      this.stopHeartbeat(); // 停止心跳
      this.reconnect();
    },

    /**
     * WebSocket错误处理
     */
    handleWsError(error) {
      console.error('WebSocket错误:', error);
      this.wsConnected = false;
      this.stopHeartbeat(); // 停止心跳
    },

    /**
     * 断线重连
     */
    reconnect() {
      if (this.reconnectAttempts < this.maxReconnectAttempts) {
        this.reconnectAttempts++;
        console.log(`WebSocket重连中... (${this.reconnectAttempts}/${this.maxReconnectAttempts})`);

        // 延迟重连
        setTimeout(() => {
          this.createWebSocket();
        }, this.reconnectInterval);
      } else {
        console.error('WebSocket重连失败，已达到最大重连次数');
      }
    },

    /**
     * 关闭WebSocket连接
     */
    closeWebSocket() {
      if (this.ws) {
        this.ws.close();
        this.ws = null;
        this.wsConnected = false;
        this.stopHeartbeat(); // 停止心跳
      }
    },

    async loadExamHouseData() {
      this.loading = true;
      try {
        // Load exam house info
        const examHouseRes = await this.$post(`/biz/isec/exam-house/houseShowDetails`, {
          examHouseId:
            this.examHouseId
        }, 3000, true, 6);
        // 过滤摄像头
        examHouseRes.data.devices.filter(device => device.deviceType === '02').forEach(device => {
          if (device.playUrl) {
            this.cameras.push({
              id: device.deviceCode,
              name: device.deviceName,
              playUrl: device.playUrl,
              accessToken: device.accessToken,
            })
            this.$nextTick(() => {
              this.playerVides.push(new EZUIKit.EZUIKitPlayer({
                id: "ezuikit-player-" + device.deviceCode, // 视频容器ID
                accessToken: device.accessToken,
                isCloudRecord: true,
                url: device.playUrl,
                // simple - 极简版; pcLive-pc直播；pcRec-pc回放；mobileLive-移动端直播；mobileRec-移动端回放;security - 安防版;voice-语音版;
                template: 'simple',
              }));
            })
          }
        })

        // 获取空气传感器-正常只有一个，这里不多做判断
        // 获取第一个传感器

        examHouseRes.data.devices.filter(device => device.deviceType === '04').forEach(device => {
          this.businessId = device.deviceCode;
        })

        // 初始化WebSocket连接
        this.initWebSocket();
      } catch (error) {
        console.log(error)
        console.error('Failed to load exam house data:', error);
        this.showMessage('加载失败');
      } finally {
        this.loading = false;
      }
    },
    startDataUpdates() {
    },

    async controlLock(shouldUnlock) {
      this.lockLoading = true;
      try {
        // TODO 锁
        this.lockStatus = shouldUnlock
      } catch (error) {
        console.error('Failed to control electronic lock:', error);
        this.showMessage(shouldUnlock ? this.$t('examination.unlockFailed') : this.$t('examination.lockFailed'));
      } finally {
        this.lockLoading = false;
      }
    },

    /**
     * 切换全屏状态
     */
    toggleFullScreen() {
      this.$emit('fullscreen');
    },

    /**
     * 报警复位方法
     * 注意：具体逻辑由用户自行实现
     */
    resetAlarm() {
      // 用户可在此处添加报警复位的具体逻辑
      // 改为then
      this.$post(`/biz/isec/exam-house/reset`, {
        examHouseId: this.examHouseId,
        examAreaId: this.examAreaId
      }, 3000, true, 6).then(res => {
        if (res.status === '0') {
          this.showMessage({
            type: "success",
            message: "报警复位成功",
          });
          this.$router.back();
        } else {
            if (res.message) {
              this.showMessage(res.message);
            }
          }
      }).catch(err => {
        console.error('Failed to reset alarm:', err);
        this.showMessage('报警复位失败');
      })
    },
    showMessage(msg) {
      this.messageBox.message = msg;
      this.messageBox.countdown = this.messageBox.defaultCount;
      document.getElementById('messageDialog').showModal();
      if (!this.messageBox.timer) {
        this.messageBox.timer = setInterval(()=> {
          this.messageBox.countdown--;
          if (this.messageBox.countdown == 0) {
            document.getElementById('messageDialog').close();
            clearInterval(this.messageBox.timer);
            this.messageBox.timer = null;
          }
        }, 1000);  
      }
    }
  },

  mounted() {
  },

  beforeRouteLeave(to, from, next) {
    // 在路由离开前销毁播放器
    if (this.playerVides && this.playerVides.length) {
      this.playerVides.forEach(player => {
        player.destroy(); // 销毁 video.js 播放器
      });
    }
    next();
  },

  beforeDestroy() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
    // 关闭WebSocket连接
    this.closeWebSocket();
    // 停止用户行为事件获取定时器
    this.stopUserEventsTimer();
  }
};
</script>

<style scoped lang="less">
.exam-house-monitor {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;

    .breadcrumbs {
      font-size: 14px;
    }

    .page-title {
      display: flex;
      align-items: center;
      gap: 20px;

      h3 {
        font-size: 18px;
        font-weight: bold;
        margin: 0;
      }

      .ws-status {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        padding: 4px 12px;
        border-radius: 16px;
        background-color: #f0f0f0;

        .status-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #f5222d;
        }

        &.connected {
          background-color: #f6ffed;

          .status-dot {
            background-color: #52c41a;
          }

          .status-text {
            color: #52c41a;
          }
        }

        &.disconnected {
          background-color: #fff1f0;

          .status-dot {
            background-color: #f5222d;
          }

          .status-text {
            color: #f5222d;
          }
        }
      }
    }
  }

  .monitor-container {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
    position: relative;

    // 考试仓名称标题样式
    .exam-house-title {
      text-align: center;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 2px solid #1890ff;
      position: relative;

      h2 {
        margin: 0;
        font-size: 24px;
        color: #1890ff;
        font-weight: 600;
      }

      .alarm-reset-btn {
        position: absolute;
        top: 0;
        right: 100px;
        background: #faad14;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 8px 12px;
        cursor: pointer;
        font-size: 16px;
        transition: background-color 0.3s;

        &:hover {
          background: #ffc53d;
        }
      }

    .back-btn {
        position: absolute;
        top: 0;
        right: 50px;
        background: #1890ff;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 8px 12px;
        cursor: pointer;
        font-size: 16px;
        transition: background-color 0.3s;

        &:hover {
          background: #40a9ff;
        }
      }
      .fullscreen-btn {
        position: absolute;
        top: 0;
        right: 0;
        background: #1890ff;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 8px 12px;
        cursor: pointer;
        font-size: 16px;
        transition: background-color 0.3s;

        &:hover {
          background: #40a9ff;
        }
      }
    }

    /* 全屏样式 */
    &:fullscreen,
    &:-webkit-full-screen,
    &:-moz-full-screen,
    &:-ms-fullscreen {
      padding: 40px;
      background-color: #fff;
      z-index: 9999;
    }

    /* 修复全屏时标题样式 */
    &:fullscreen .exam-house-title,
    &:-webkit-full-screen .exam-house-title,
    &:-moz-full-screen .exam-house-title,
    &:-ms-fullscreen .exam-house-title {
      margin-bottom: 40px;
    }

    /* 修复全屏时视频网格布局 */
    &:fullscreen .video-grid,
    &:-webkit-full-screen .video-grid,
    &:-moz-full-screen .video-grid,
    &:-ms-fullscreen .video-grid {
      grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
      gap: 30px;
    }

    /* 修复全屏时视频高度 */
    &:fullscreen .video-content,
    &:-webkit-full-screen .video-content,
    &:-moz-full-screen .video-content,
    &:-ms-fullscreen .video-content {
      height: 250px;
    }

    /* 修复全屏时环境监测和预警容器 */
    &:fullscreen .monitor-alerts-container,
    &:-webkit-full-screen .monitor-alerts-container,
    &:-moz-full-screen .monitor-alerts-container,
    &:-ms-fullscreen .monitor-alerts-container {
      gap: 30px;
    }

    .video-monitors,
    .device-status {
      margin-bottom: 30px;

      .video-title,
      .device-title {
        margin-bottom: 16px;

        h3 {
          font-size: 18px;
          color: #333;
          margin: 0;
          padding-bottom: 8px;
          border-bottom: 1px solid #e6e6e6;
        }
      }
      
      // 查看截图按钮样式
        .view-screenshot-btn {
          padding: 4px 12px;
          background-color: #1890ff;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 12px;
          margin-left: 10px;

          &:hover {
            background-color: #40a9ff;
          }

          .el-icon-picture {
            margin-right: 4px;
          }
        }
      }

      // 自定义截图弹窗四比三样式
      .screenshot-dialog {
        width: 680px !important;
        height: 510px !important; /* 680 * 0.75 = 510，实现四比三比例 */
        position: fixed !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        margin: 0 !important;
        max-width: 90vw;
        max-height: 90vh;
      }
      
      .screenshot-dialog .el-dialog__wrapper {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      // 截图弹窗内容样式
      .screenshot-container {
        width: 100%;
        height: 450px; /* 调整高度以适应四比三对话框 */
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        background-color: #f5f5f5;

        .screenshot-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          padding: 20px;

          .screenshot-image {
            width: 100%;
            object-fit: contain !important;
            display: block;
          }
        }

        .no-image {
          text-align: center;
          color: #999;

          .el-icon-picture-outline {
            font-size: 48px;
            margin-bottom: 16px;
          }

          p {
            font-size: 16px;
          }
        }
    }

    .video-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 20px;
    }

    .video-item {
      border: 1px solid #e6e6e6;
      border-radius: 8px;
      overflow: hidden;

      .video-header {
        background-color: #1890ff;
        color: #fff;
        padding: 10px 16px;

        h4 {
          margin: 0;
          font-size: 14px;
        }
      }

      .video-content {
        width: 100%;
        height: 180px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .device-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 20px;
    }

    /* 环境监测和考生行为预警在一行显示 */
    .monitor-alerts-container {
      display: flex;
      gap: 20px;
      margin-bottom: 20px;
    }

    /* 环境监测占30%宽度 */
    .environment-monitor {
      width: 30%;
      min-width: 250px;
    }

    /* 考生行为预警占70%宽度 */
    .exam-alerts {
      width: 70%;
      min-width: 350px;
    }

    .environment-monitor,
    .electronic-lock,
    .other-device {
      border: 1px solid #e6e6e6;
      border-radius: 8px;
      padding: 16px;
      background-color: #fff;

      h4 {
        margin-top: 0;
        margin-bottom: 16px;
        font-size: 16px;
        color: #333;
        padding-bottom: 8px;
        border-bottom: 1px solid #e6e6e6;
      }
    }

    .environment-items {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;

      .environment-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px;
        background-color: #fafafa;
        border-radius: 4px;

        .item-label {
          font-size: 12px;
          color: #666;
        }

        .item-value {
          font-size: 14px;
          font-weight: 500;
          color: #333;
        }
      }
    }

    .electronic-lock {
      .lock-status {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;

        .status-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;

          &.locked {
            background-color: #f5222d;
            color: #fff;
          }

          &.unlocked {
            background-color: #52c41a;
            color: #fff;
          }
        }

        .status-text {
          font-size: 16px;
          color: #333;
        }
      }

      .lock-operations {
        display: flex;
        justify-content: center;
      }
    }

    .other-device {
      .device-status {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .status-indicator {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          margin-right: 8px;

          &.online {
            background-color: #52c41a;
          }

          &.offline {
            background-color: #f5222d;
          }
        }

        .status-text {
          font-size: 14px;
          color: #333;
        }
      }

      .device-info {
        p {
          font-size: 12px;
          color: #666;
          margin: 0;
        }
      }
    }

    // 考生行为预警样式
    .exam-alerts {
      border: 1px solid #e6e6e6;
      border-radius: 8px;
      padding: 16px;
      background-color: #fff;

      h4 {
        margin-top: 0;
        margin-bottom: 16px;
        font-size: 16px;
        color: #333;
        padding-bottom: 8px;
        border-bottom: 1px solid #e6e6e6;
      }

      .alert-list {
        max-height: 200px;
        overflow-y: auto;
      }

      .alert-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        margin-bottom: 8px;
        background-color: #fff1f0;
        border-radius: 4px;
        font-size: 14px;
        color: #f5222d;

        &:last-child {
          margin-bottom: 0;
        }

        .alert-type {
          font-weight: 500;
        }

        .alert-camera {
          flex: 1;
          text-align: center;
        }

        .alert-time {
          font-size: 12px;
          color: #999;
        }
      }

      .no-alerts {
        text-align: center;
        color: #999;
        padding: 20px 0;
        font-size: 14px;
      }
    }
  }
}
</style>